import { useCallback } from "react";
import { useAccount, useWriteContract } from "wagmi";
import { waitForTransactionReceipt } from "@wagmi/core";
import { parseEther } from "viem";
import institusionAbi from "../../utils/institusion.json";
import Environment from "../../utils/Environment";
import { wagmiConfig } from "../../wagmiConfig";

const usePurchaseEth1 = () => {
  const { address: account, isConnected } = useAccount();
  const { writeContractAsync } = useWriteContract();

  const purchaseEth1 = useCallback(
    async (min, amount, postApiRes, id, balance) => {
      if (!isConnected || !account) throw new Error("WALLET_NOT_CONNECTED");

      const fixedAmount = Math.round(parseFloat(amount).toFixed(6) * 1e12) / 1e12;
      const nd = parseEther(fixedAmount.toString());

      let minvalue = min * 0.99;
      minvalue = Math.round(parseFloat(minvalue).toFixed(6) * 1e12) / 1e12;
      minvalue = parseEther(minvalue.toString());

      console.log(postApiRes.code, id, postApiRes.price, postApiRes.deadline, minvalue, "usePurchaseEth1 params");

      try {
        const hash = await writeContractAsync({
          address: Environment.instituson,
          abi: institusionAbi,
          functionName: "purchaseWithETH",
          args: [
            postApiRes.code,
            id,
            postApiRes.price,
            postApiRes.deadline,
            minvalue,
            postApiRes?.v,
            postApiRes?.r,
            postApiRes?.s,
          ],
          value: nd,
        });

        console.log("PurchaseEth1 tx hash:", hash);

        const receipt = await waitForTransactionReceipt(wagmiConfig, { hash });

        console.log("PurchaseEth1 confirmed:", receipt);

        return { transactionHash: hash, receipt };
      } catch (error) {
        console.error("PurchaseEth1 error:", error);
        throw error;
      }
    },
    [account, isConnected, writeContractAsync]
  );

  return { purchaseEth1 };
};

export default usePurchaseEth1;
